/**
 * @param  {object} options
 * @param  {Array} routes
 * @return {Array}
 */
export const mapRoutes = (options, routes) => {
  routes.forEach(route => route.meta = { ...route.meta, ...options });
  return routes;
};
